// A donut with its own legend: polaris-viz colours the ring from each slice's `color` but draws the built-in legend
// swatches from its default theme, so the two disagreed (Eric, 2026-10-18). Slices come as
// [{ name, color, data: [{ key, value }] }]; `format` formats the values.
import React from 'react';
import { DonutChart } from '@shopify/polaris-viz';

export default function ColorDonut({ data, format = v => Number(v).toLocaleString(), height = 300, showPct = true }) {
    const total = data.reduce((s, d) => s + (d.data[0]?.value || 0), 0) || 1;
    return (
        <div style={{ display: 'flex', gap: 16, alignItems: 'center', height, minWidth: 0 }}>
            <div style={{ flex: '0 1 300px', minWidth: 160, maxHeight: height, overflowY: 'auto', fontSize: 13 }}>
                {data.map(d => {
                    const v = d.data[0]?.value || 0;
                    return (
                        <div key={d.name} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '3px 0' }}>
                            <span style={{ width: 11, height: 11, borderRadius: 3, background: d.color, flex: 'none' }} />
                            <span style={{ flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={d.name}>{d.name}</span>
                            <span style={{ fontVariantNumeric: 'tabular-nums' }}>{format(v)}</span>
                            {showPct && <span style={{ fontVariantNumeric: 'tabular-nums', color: '#6d7175', width: 44, textAlign: 'right' }}>{(v / total * 100).toFixed(1)}%</span>}
                        </div>
                    );
                })}
            </div>
            <div style={{ flex: 1, minWidth: 0, height }}>
                <DonutChart data={data} showLegend={false} labelFormatter={format} tooltipOptions={{ valueFormatter: format }} />
            </div>
        </div>
    );
}
